<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pt-5 pt-md-8">
            
    </base-header>
    <div class="card shadow"
            >
      <div class="card-header border-0"
             >
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0">
              Tiêu Chí
            </h3>
          </div>

          <div class="col text-right">
            <base-button type="info" class="btn-sm" @click="modals.modal1 = true">Add</base-button>
                  <modal :show.sync="modals.modal1">
                  <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel1">Tiêu Chí</h5>
                  </template>
                  <div>
                    <base-input alternative  placeholder="Tên tiêu chí" v-model="name">
                    </base-input>
                    <base-input  alternative  placeholder="Tỷ trọng" v-model="score">
                    </base-input>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal1 = false">Close</base-button>
                    <base-button type="primary" @click="createCanon">Save</base-button>
                  </template>
                </modal>
          </div>
        </div>
      </div>

      <div class="table-responsive">
              <base-table class="table align-items-center table-flush"
                  
                  
                  tbody-classes="list"
                  :data="canons">
                <template slot="columns">
                  <th>Tên</th>
                  <th>Tỷ Trọng</th>
                  <th></th>
                </template>

                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{row.name}}</span>
                      </div>
                    </div>
                  </th>
                  <td class="budget">
                    {{row.score}}
                  </td>
                  <td class="col-3 text-right">
                    <base-button type="warning" class="btn-sm" @click="editCanon(row)">Edit</base-button>
                  <modal :show.sync="modals.modal0">
                  <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Tiêu Chí</h5>
                  </template>
                  <div>
                    <base-input v-model="canon.name">
                    </base-input>
                    <base-input v-model="canon.score">
                    </base-input>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal0 = false">Close</base-button>
                    <base-button type="primary" @click="updateCanon()">Update</base-button>
                  </template>
                </modal>
                    <base-button type="danger" class="btn btn-danger btn-sm" @click="deleteCanon(row)" >Delete</base-button>
                  </td>
                </template>

              </base-table>
            </div>

    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  data() {
    return {
      name: null,
      score: null,
      canons: [],
      canon: {},
      modals: {
        modal0: false,
        modal1: false
      },

    }
  },
  methods: {
    async getCanons() {
     let res = await this.$http.get('/canon')
     this.canons = res.data
    },
    createCanon() {
      let data = {
        name: this.name,
        score: this.score
      }
      this.canons.push(data)
      this.$http.post('/canon/add', data)
      this.name = null
      this.score = null
      this.modals.modal1 = false
    },
    async deleteCanon(canon) {
      let data = { canonid: canon._id}
      await this.$http.post('/canon/delete', data)
      this.canons = _.without(this.canons, canon)
    },
    async updateCanon() {
      await this.$http.post('/canon/edit', this.canon )
      this.modals.modal0 = false
    },
    editCanon(canon) {
      this.canon = canon
      this.modals.modal0 =true
    }

  },
  mounted() {
    this.getCanons()
  }
}
</script>
<style>

</style>